import { render, staticRenderFns } from "./SelectDesformAuthModal.vue?vue&type=template&id=48f06980&scoped=true&"
import script from "./SelectDesformAuthModal.vue?vue&type=script&lang=js&"
export * from "./SelectDesformAuthModal.vue?vue&type=script&lang=js&"
import style0 from "./SelectDesformAuthModal.vue?vue&type=style&index=0&id=48f06980&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f06980",
  null
  
)

export default component.exports